import type { Props } from './Svg'
import { Svg } from './Svg'

export function Sun2Icon(props: Props) {
  return (
    <Svg width="49" height="48" {...props}>
      <path
        fill="currentColor"
        d="M45.5 21.5h-6c-.4-2.5-1.4-4.8-2.8-6.7l4.2-4.2c1-1 1-2.5 0-3.5s-2.5-1-3.5 0l-4.2 4.2a15.4 15.4 0 0 0-6.7-2.8v-6C26.5 1.1 25.4 0 24 0a2.5 2.5 0 0 0-2.5 2.5v6c-2.5.4-4.8 1.4-6.7 2.8l-4.2-4.2c-1-1-2.5-1-3.5 0s-1 2.5 0 3.5l4.2 4.2a15.4 15.4 0 0 0-2.8 6.7h-6A2.5 2.5 0 0 0 0 24c0 1.4 1.1 2.5 2.5 2.5h6c.4 2.5 1.4 4.8 2.8 6.7l-4.2 4.2c-1 1-1 2.5 0 3.5.5.5 1.1.7 1.8.7s1.3-.2 1.8-.7l4.2-4.2c1.9 1.4 4.2 2.4 6.7 2.8v6c0 1.4 1.1 2.5 2.5 2.5s2.5-1.1 2.5-2.5v-6c2.5-.4 4.8-1.4 6.7-2.8l4.2 4.2c.5.5 1.1.7 1.8.7s1.3-.2 1.8-.7c1-1 1-2.5 0-3.5l-4.2-4.2c1.4-1.9 2.4-4.2 2.8-6.7h6c1.4 0 2.5-1.1 2.5-2.5s-1.4-2.5-2.7-2.5ZM24 34.7a10.7 10.7 0 1 1 0-21.4 10.7 10.7 0 0 1 0 21.4Z"
      />
    </Svg>
  )
}
